module.exports = __webpack_public_path__ + "static/img/quanmin03_header.673016ec.png";